import type { EvidenceId } from "../types";

export type AssessmentId = "core" | "structure" | "methods" | "case-1962" | "attitude";

export interface ChoiceAssessment {
  id: Exclude<AssessmentId, "core">;
  title: string;
  prompt: string;
  options: readonly string[];
  answer: number;
  evidenceIds: readonly EvidenceId[];
  correctionHint: string;
}

export const ASSESSMENT_IDS: readonly AssessmentId[] = ["core", "structure", "methods", "case-1962", "attitude"];

export const CORE_BLANKS = [
  { id: "phenology", prompt: "课文把草木荣枯、候鸟去来等能反映时节变化的自然现象称为什么？", answer: "物候", evidence: "P03" },
  { id: "longitude", prompt: "课文用大连和北京花期不同说明：同纬度附近，沿海与内陆的物候差异主要受哪个因素影响？", answer: "经度", evidence: "P08" },
  { id: "elevation", prompt: "课文说春夏高处抽青、开花较迟，这属于哪个影响物候的因素？", answer: "高下", evidence: "P09" },
  { id: "latitude", prompt: "课文说越往北桃花开得越迟、候鸟来得越晚，这主要受哪个因素影响？", answer: "纬度", evidence: "P07" }
] as const satisfies readonly { id: string; prompt: string; answer: string; evidence: EvidenceId }[];

export const WORD_BANK = ["物候", "物候学", "纬度", "经度", "高下", "古今"] as const;

export const CHOICE_ASSESSMENTS: readonly ChoiceAssessment[] = [
  {
    id: "structure",
    title: "行文结构",
    prompt: "文章整体行文结构排序正确的一项是（　）。",
    options: [
      "引出物候、物候学概念 → 物候观测的农业价值 → 影响物候的四个因素 → 物候学的现实研究意义",
      "解释物候学定义 → 列举四季物候 → 农业应用价值 → 总结号召",
      "大自然四季景观 → 分析物候影响因素 → 举例物候观测失误 → 界定物候学",
      "农谚引入物候 → 纬度、经度、高下、古今因素 → 北京播种实例 → 物候学学科归属"
    ],
    answer: 0,
    evidenceIds: ["P01", "P03", "P04", "P06", "P11", "P12"],
    correctionHint: "先分辨文章是在何处提出概念、说明价值、分析因素并落到研究意义。"
  },
  {
    id: "methods",
    title: "说明方法",
    prompt: "南京与北京花期差异的句子所用说明方法组合正确的是（　）。",
    options: [
      "举例子、列数字、作比较",
      "作诠释、引用、打比方",
      "分类别、列数字、摹状貌",
      "下定义、作比较、引用"
    ],
    answer: 0,
    evidenceIds: ["P07"],
    correctionHint: "留意句中的具体城市、二十天和十天，以及两地花期的比较。"
  },
  {
    id: "case-1962",
    title: "1962 年推理",
    prompt: "根据 1962 年北京的物候与播种案例，合理推论是（　）。",
    options: [
      "气候每年固定不变，损害只由作物品种不耐寒造成。",
      "物候观测可综合反映相关气候条件，并为调整播种日期、避免可能的农业损失提供参考。",
      "物候观测没有实际参考价值。",
      "北方春季低温完全不可预判。"
    ],
    answer: 1,
    evidenceIds: ["P05", "P11"],
    correctionHint: "区分“提供参考、可能避免”和“保证避免、完全预判”的不同。"
  },
  {
    id: "attitude",
    title: "科学态度",
    prompt: "文章既肯定古代农谚的价值，又介绍近代物候学，体现了怎样的科学态度？",
    options: [
      "全盘否定传统农耕经验",
      "辩证看待，吸收传统经验中的合理内容，并发展为系统的科学研究",
      "一味照搬古代农时经验，拒绝科学观测",
      "认为传统农谚完全等同于现代物候学"
    ],
    answer: 1,
    evidenceIds: ["P03"],
    correctionHint: "比较“古代农谚包含知识”和“近代发展为一门科学”这两层表述。"
  }
];
